import React, { useRef, useEffect, useState } from 'react';

const ColorPickerModal = ({
  isOpen,
  onClose,
  position,
  children,
  bottomPanelSelector = null,
}) => {
  const modalRef = useRef(null);
  const contentRef = useRef(null);
  const [adjustedTop, setAdjustedTop] = useState(position.top);

  // After render, measure actual height and reposition if needed
  useEffect(() => {
    if (!isOpen || !contentRef.current) return;

    const rect = contentRef.current.getBoundingClientRect();
    const actualHeight = rect.height;

    const bottomPanel = bottomPanelSelector
      ? document.querySelector(bottomPanelSelector)
      : null;
    const bottomBoundary = bottomPanel
      ? bottomPanel.getBoundingClientRect().top
      : window.innerHeight;

    // If picker overflows bottom boundary, push it up
    if (position.top + actualHeight > bottomBoundary - 20) {
      const corrected = Math.max(20, bottomBoundary - actualHeight - 20);
      setAdjustedTop(corrected);
    } else {
      setAdjustedTop(position.top);
    }
  }, [isOpen, position, bottomPanelSelector]);

  const handleClickOutside = (event) => {
    if (
      contentRef.current &&
      !contentRef.current.contains(event.target) &&
      !event.target.closest('.color-trigger')
    ) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div ref={modalRef} className="fixed inset-0 z-[9999]">
      <div
        ref={contentRef}
        className="rounded shadow-2xl"
        style={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #333',
          position: 'absolute',
          top: `${adjustedTop}px`,
          left: `${position.left}px`,
          maxWidth: 'calc(100vw - 40px)',
          maxHeight: 'calc(100vh - 40px)',
          transform: window.innerWidth < 1024 ? 'scale(0.75)' : 'scale(1)',
          transformOrigin: 'top left',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-2">
          <div className="flex items-center justify-end">
            <button
              onClick={onClose}
              title="Close color picker"
              className="p-1 hover:bg-gray-700 rounded transition-colors"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div className="overflow-auto max-h-[calc(100vh-120px)]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorPickerModal;
